import React from "react";
import './ProgressBar.scss'

interface ProgressBarProp {
	progressPercentage: number;
}

const ProgressBar: React.FC<ProgressBarProp> = ({progressPercentage}): JSX.Element => {
	return (
		<div className="progress-row">
			<div id="progressFrame">
				<div id="progressBar" style={{width: `${progressPercentage}%`} }></div>
				<div className="progressCell ng-star-inserted">Details</div>
				<div className="progressCell ng-star-inserted">Goals</div>
				<div className="progressCell ng-star-inserted">Diet</div>
				<div className="progressCell ng-star-inserted">Activity</div>
				<div className="progressCell ng-star-inserted">Results</div>
			</div>
		</div>
	);
};

export default ProgressBar;
